import { Table, Spinner, Badge, Button } from "react-bootstrap";
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import BasicModal from "../Modals/Basic.modal";
import { MCQQuestionCard } from "../../views/AiQuestions/Questions";
import toast from "react-hot-toast";
import { AiQuestionService } from "../../services/aiQuestion.service";


interface ITranslatorQuestions {
    loading: boolean;
    data: any;
    reload: any;
}

export default function AiQAQuestionsTable({ data, loading, reload }: ITranslatorQuestions) {

    const [selectedQuestion, setSelectedQuestion] = useState<any>(null);

    async function approveQuestion() {
        if (!selectedQuestion?._id) {
            toast.error("Something went wrong");
            return
        }

        // await AiQuestionService.approveQuestion()
        //     .then((res) => {
        //         if (res.status === 200) {
        //             toast.success("Question approved successfully");
        //             setSelectedQuestion(null);
        //             reload();
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         toast.error(err.response?.data?.message || err?.response || "Something went wrong");
        //     })
    }

    return (
        <>
            <Table striped hover size="sm" className="xcn-text-12" responsive>
                <thead>
                    <tr className='text-secondary'>
                        <th>#</th>
                        <th>Internal Id</th>
                        <th>Subject</th>
                        <th>Topic</th>
                        <th>Language</th>
                        <th>Grade</th>
                        <th>Toughness</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ?
                            <tr><td colSpan={5} className='text-center'> <Spinner animation="border" variant="primary" size="sm" /> Loading...</td></tr> :
                            data && data?.length > 0 ? data?.map((item: any, index: any) => {
                                return (
                                    <>
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td className='fw-bold xcn-text-10'>{item?._id}</td>
                                            <td className='fw-bold xcn-text-10'>{item?.subject || "N/A"}</td>
                                            <td className='fw-bold xcn-text-10'>{item?.topic || "N/A"}</td>
                                            <td className="fw-bold text-secondary">{item?.language?.toUpperCase()}</td>
                                            <td className="fw-bold">{item?.grade?.toUpperCase()}</td>
                                            <td className="fw-bold">{item?.toughness?.toUpperCase()}</td>
                                            <td>{item?.isVerified ? <Badge bg="success">Verified</Badge> : <Badge bg="danger">Not Verified</Badge>}</td>
                                            <td>
                                                <FontAwesomeIcon
                                                    className="text-primary"
                                                    icon={faEye}
                                                    onClick={() => {
                                                        setSelectedQuestion(item);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </>
                                )
                            }) :
                                <tr><td colSpan={5} className='text-center'>No Questions Found </td></tr>
                    }
                </tbody>
            </Table>

            <BasicModal
                show={selectedQuestion?._id}
                setShow={() => setSelectedQuestion(null)}
                size="lg"
                heading="Question Details"
                body={
                    <>
                        <MCQQuestionCard data={selectedQuestion?.metaData} showSelect={false} />
                        <div className="d-flex justify-content-end gap-2">
                            <Button size="sm" variant="secondary" onClick={() => setSelectedQuestion(null)}>
                                Close
                            </Button>
                            <Button size="sm" variant="primary" onClick={approveQuestion}>
                                Approve Question
                            </Button>
                        </div>
                    </>
                }
            />
        </>
    )
}  